import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#474747"><path d="M6 11.953V14H.469a.464.464 0 00-.469.469v1.062c0 .263.206.469.469.469H13.53a.464.464 0 00.469-.469V14.47a.464.464 0 00-.469-.469H8v-2.047z" /><path d="M4.008 2.273v5.723H10v-4.05L8 2.007H4.273c-.172 0-.265.094-.265.265zM2.984 8.01C2.422 8.01 2 8.36 2 9v2.969h9.969V9c0-.641-.406-.988-.953-.988l-.002.978-8.03.035z" style={{
        marker: "none"
      }} color="#000" overflow="visible" /></g></svg>;
}

export default SvgComponent;